import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiActivity } from 'react-icons/fi';
import GlassCard from '../../components/ui/GlassCard';
import AgenciesTab from './tabs/AgenciesTab';
import CheckNowTab from './tabs/CheckNowTab';
import RecentReports from './tabs/RecentReports';
import SettingsTab from './tabs/SettingsTab';
import ScheduleTab from './tabs/ScheduleTab';
import '../../styles/CarrierAccess.css';
import '../../styles/IvansMonitor.css';

type TabKey = 'home' | 'settings' | 'schedule';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'home', label: 'Home' },
  { key: 'settings', label: 'Settings' },
  { key: 'schedule', label: 'Schedule' },
];

const IvansMonitorPage: React.FC = () => {
  const [active, setActive] = useState<TabKey>('home');

  return (
    <div className="ca-page">
      <motion.div
        className="ca-content"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div className="ca-header">
          <div className="ca-header__title-row">
            <div className="ca-header__icon">
              <FiActivity size={20} />
            </div>
            <div>
              <div className="ca-header__title">IVANS Monitor</div>
              <div className="ca-header__subtitle">
                Cross-carrier IVANS Exchange monitoring — expiring/delayed delivery alerts across every agency you track.
              </div>
            </div>
          </div>
        </div>

        <div className="ivm-tabbar">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`ivm-tabbar__btn ${active === tab.key ? 'ivm-tabbar__btn--active' : ''}`}
              onClick={() => setActive(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <GlassCard padding="var(--space-5)">
          {active === 'home' && (
            <div className="ivm-home">
              <AgenciesTab />
              <div className="ivm-divider" />
              <CheckNowTab />
              <div className="ivm-divider" />
              <RecentReports onOpenSchedule={() => setActive('schedule')} />
            </div>
          )}
          {active === 'settings' && <SettingsTab />}
          {active === 'schedule' && <ScheduleTab />}
        </GlassCard>
      </motion.div>
    </div>
  );
};

export default IvansMonitorPage;
